import React from 'react'
import { SearchFilterProvider } from '../../../views/providers'
import { ContactsProvider, ContactsPage } from '..'
import CustomerStatement from '../../accounting/components/CustomerStatement/CustomerStatement'
import ConsolidatedCustomerStatement from '../../accounting/components/ConsolidatedCustomerStatement/ConsolidatedCustomerStatement'
import CustomerDepositStatement from '../../accounting/components/CustomerDepositStatement/CustomerDepositStatement'

const ContactsRoute = (props: any) => (
  <ContactsProvider {...props}>
    <SearchFilterProvider location={props.location}>
      <ContactsPage />
      <CustomerStatement />
      <ConsolidatedCustomerStatement />
      <CustomerDepositStatement />
    </SearchFilterProvider>
  </ContactsProvider>
)

export default ContactsRoute
